module.exports = __webpack_public_path__ + "img/work_overtime_count.8a8e4336.svg";